<template lang="html">
  <div
    id="loginModal"
    class="login modal fade"
    :class="{ 'd-none': inApp }"
    data-backdrop="false"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close login-close" @click="closeFrom">
          <font-awesome-icon :icon="[ 'fas', 'times' ]" />
        </button>
        <div class="modal-body">
          <h5 class="text-primary text-center p-3 m-0">Bienvenid@</h5>
<!--          <div class="py-3">-->
<!--            <button type="button"-->
<!--                    class="btn btn-lg btn-fb mx-auto col-12 col-sm-7"-->
<!--                    @click="loginSocial('facebook')">-->
<!--              <span class="fa fa-facebook my-auto"></span>-->
<!--              <span class="my-auto pl-2">Entrar con Facebook</span>-->
<!--            </button>-->
<!--          </div>-->
          <div class="py-3">
            <button type="button"
                    class="btn btn-lg btn-ggl mx-auto col-12 col-sm-7"
                    @click="loginSocial('google')">
              <svg class="btn-ggl-logo my-auto" viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg">
                <path d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z" fill="#4285f4" />
                <path d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z" fill="#34a853" />
                <path d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z" fill="#fbbc04" />
                <path d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z" fill="#ea4335" />
              </svg>
              <span class="my-auto pl-2">Entrar con Google</span>
            </button>
          </div>
          <h6
            v-show="!showForm"
            class="login-options text-center pt-3 pb-2"
            @click="showForm = !showForm">
            Mostrar más opciones
            <span class="fa fa-chevron-down text-primary px-2"></span>
          </h6>
          <LoginDialogForm
            v-if="showForm"
            @close="closeFrom"
            @logged="onLogged" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api, urls} from '@/api'
import $ from 'jquery'
import LoginDialogForm from '@/components/layout/LoginDialogForm'
import storage from '@/localStorage'
import store from '@/store'
import {instance as snack} from '@/components/layout/SnackMessage'

export default {
  components: {
    LoginDialogForm
  },

  data: () => ({
    showForm: false
  }),

  computed: {
    name: () => store.getters['user/name'],

    inApp: () => localStorage.getItem('appmobile') && localStorage.getItem('appmobile') == 'true'
  },

  methods: {

    onLogged () {
      store.dispatch('user/fetchUserInfo')
        .then(() => {
          this.showForm = false
          $(this.$el).modal('hide')
          const redirect = this.$route && this.$route.query.redirect

          setTimeout(() => {
            snack({
              title: `Bienvenid@${ this.name ? ` ${this.name}!` : '!' }`,
              text: 'Has iniciado sesión correctamente.'
            })
          }, 500)

          if (redirect) this.$router.push({ path: redirect })
        })
    },

    closeFrom () {
      this.showForm = false
      $(this.$el).modal('hide')
    },

    loginSocial (social) {
      api.get(urls[social])
        .then(({data}) => {
          let a = window.open(data.data.redirectUrl, 'log', 'height=600,width=800')

          if (!a) {
            return
          }

          const interval = setInterval(() => { a.postMessage('doIt', '*') }, 500)

          const link = e => {
            if (e.data === 'OMW') {
              removeEventListener('message', link)
              clearInterval(interval)
            }
          }

          addEventListener('message', link)

          const closeWindow = e => {
            if (e.data === 'logged') {
              const {bearer, refresh} = storage.getTokens()
              store.dispatch('user/setTokens', { token: bearer, refresh })
              a.close()
              this.onLogged()
              this.pushToDataLayer('Login dialog', `Login ${social}`)
              removeEventListener('message', closeWindow)
            }
          }
          addEventListener('message', closeWindow)
        })
    }
  },

  mounted () {

    // Show and remove the "login" hash from the URL. It is needed for the app to intercept the login modal opening
    $(this.$el).on('show.bs.modal', e => {

      history.pushState(null, null, '#login')

      if (this.inApp) {
        setTimeout(() => $(this.$el).modal('hide'), 1500);
      }
    })

    // Remove the #login when the modal is closed
    $(this.$el).on('hide.bs.modal', e => {
      history.replaceState(null, null, window.location.href.replace('#login', ''));
    })

  }
}
</script>

<style lang="scss">
@import "/../../scss/breakpoints";

#loginModal{
  background-color: rgba(0, 0, 0, 0.5);
}

.login {
  .btn-fb {
    display: flex;
    padding: 8px;
    background-color: #3b5998;
    color: #fff;
    font-weight: bold;
    font-size: 18px;

    @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
      padding: 8px;
    }
  }

  .btn-ggl {
    display: flex;
    padding: 8px;
    background-color: #4285F4;
    color: #fff;
    font-weight: bold;
    font-size: 18px;

    &-logo {
      width: 28px;
      height: 28px;
      padding: 2px;
      background-color: #fff;
      border-radius: 3px;

      @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
        width: 34px;
        height: 34px;
        padding: 4px;
      }
    }
  }

  //.fa-facebook, .login {
  //  padding-top: 2px;
  //  width: 28px;
  //  height: 28px;
  //  border-radius: 3px;
  //  font-size: 1.5rem;
  //  background-color: #fff;
  //  color: #3b5998;
  //
  //  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
  //    padding-top: 4px;
  //    font-size: 1.75rem;
  //    width: 34px;
  //    height: 34px;
  //  }
  //}

  .modal-content {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &-close {
    position: absolute;
    padding: 5px 15px 20px 25px !important;
    z-index: 1;
    top: 0.5rem;
    right: 0.5rem;
  }

  &-options {
    cursor: pointer;
  }

  &-text {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LoginDialog.vue